import axios from 'axios';

axios.defaults.withCredentials = true;

const api = axios.create({
  baseURL: `${process.env.REACT_APP_API_BASE_URL}/api`,
});

export default api;
